import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface GoodsInventoryEntry {
  _id?: string;
  clientId: string;
  locationId: string;
  revenueTypeId: string;
  revenueTypeName: string;
  month: number;
  year: number;
  procurement: number;
  closingStock: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface GetGoodsInventoryParams {
  clientId: string;
  months: string; // "YYYY-MM" or "YYYY-MM,YYYY-MM"
  locationId?: string;
}

export interface BulkUpsertEntry {
  clientId: string;
  locationId: string;
  revenueTypeId: string;
  revenueTypeName: string;
  month: number;
  year: number;
  procurement: number;
  closingStock: number;
}

export const getGoodsInventory = async (
  params: GetGoodsInventoryParams,
): Promise<{ data: GoodsInventoryEntry[] }> => {
  const response = await axios.get(`${BASE_API_URL}/v2/goods-inventory`, { params });
  return response.data;
};

export const bulkUpsertGoodsInventory = async (
  entries: BulkUpsertEntry[],
): Promise<{ message: string; data: GoodsInventoryEntry[] }> => {
  const response = await axios.post(`${BASE_API_URL}/v2/goods-inventory/bulk-upsert`, { entries });
  return response.data;
};
